var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 81,
    viewBox: "0 0 88 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35,
    clipPath: "url(#clip0_357_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.52588e-05 72.6577H72.8914V-0.00544739H1.52588e-05V72.6577Z",
    fill: "#00A8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.428 81H88V78.436H85.428V81Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2839 81H82.856V78.436H80.2839V81Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1399 81H77.7119V78.436H75.1399V81Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9906 81H72.5626V78.436H69.9906V81Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8466 81H67.4186V78.436H64.8466V81Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7026 81H62.2746V78.436H59.7026V81Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5585 81H57.1305V78.436H54.5585V81Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4092 81H51.9812V78.436H49.4092V81Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2651 81H46.8372V78.436H44.2651V81Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.428 75.9248H88V73.3608H85.428V75.9248Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2839 75.9248H82.856V73.3608H80.2839V75.9248Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1399 75.9248H77.7119V73.3608H75.1399V75.9248Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9906 75.9248H72.5626V73.3608H69.9906V75.9248Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8466 75.9248H67.4186V73.3608H64.8466V75.9248Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7026 75.9248H62.2746V73.3608H59.7026V75.9248Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5585 75.9248H57.1305V73.3608H54.5585V75.9248Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4092 75.9248H51.9812V73.3608H49.4092V75.9248Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2651 75.9248H46.8372V73.3608H44.2651V75.9248Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.428 70.855H88V68.291H85.428V70.855Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2839 70.855H82.856V68.291H80.2839V70.855Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1399 70.855H77.7119V68.291H75.1399V70.855Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9906 70.855H72.5626V68.291H69.9906V70.855Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8466 70.855H67.4186V68.291H64.8466V70.855Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7026 70.855H62.2746V68.291H59.7026V70.855Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5585 70.855H57.1305V68.291H54.5585V70.855Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4092 70.855H51.9812V68.291H49.4092V70.855Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2651 70.855H46.8372V68.291H44.2651V70.855Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.428 65.7803H88V63.2163H85.428V65.7803Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2839 65.7803H82.856V63.2163H80.2839V65.7803Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1399 65.7803H77.7119V63.2163H75.1399V65.7803Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9906 65.7803H72.5626V63.2163H69.9906V65.7803Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8466 65.7803H67.4186V63.2163H64.8466V65.7803Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7026 65.7803H62.2746V63.2163H59.7026V65.7803Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5585 65.7803H57.1305V63.2163H54.5585V65.7803Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4092 65.7803H51.9812V63.2163H49.4092V65.7803Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2651 65.7803H46.8372V63.2163H44.2651V65.7803Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.428 60.7051H88V58.1411H85.428V60.7051Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2839 60.7051H82.856V58.1411H80.2839V60.7051Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1399 60.7051H77.7119V58.1411H75.1399V60.7051Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9906 60.7051H72.5626V58.1411H69.9906V60.7051Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8466 60.7051H67.4186V58.1411H64.8466V60.7051Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7026 60.7051H62.2746V58.1411H59.7026V60.7051Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5585 60.7051H57.1305V58.1411H54.5585V60.7051Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4092 60.7051H51.9812V58.1411H49.4092V60.7051Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2651 60.7051H46.8372V58.1411H44.2651V60.7051Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.428 55.6353H88V53.0713H85.428V55.6353Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2839 55.6353H82.856V53.0713H80.2839V55.6353Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1399 55.6353H77.7119V53.0713H75.1399V55.6353Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9906 55.6353H72.5626V53.0713H69.9906V55.6353Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8466 55.6353H67.4186V53.0713H64.8466V55.6353Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7026 55.6353H62.2746V53.0713H59.7026V55.6353Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5585 55.6353H57.1305V53.0713H54.5585V55.6353Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4092 55.6353H51.9812V53.0713H49.4092V55.6353Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2651 55.6353H46.8372V53.0713H44.2651V55.6353Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.428 50.5601H88V47.9961H85.428V50.5601Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2839 50.5601H82.856V47.9961H80.2839V50.5601Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1399 50.5601H77.7119V47.9961H75.1399V50.5601Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9906 50.5601H72.5626V47.9961H69.9906V50.5601Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8466 50.5601H67.4186V47.9961H64.8466V50.5601Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7026 50.5601H62.2746V47.9961H59.7026V50.5601Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5585 50.5601H57.1305V47.9961H54.5585V50.5601Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4092 50.5601H51.9812V47.9961H49.4092V50.5601Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2651 50.5601H46.8372V47.9961H44.2651V50.5601Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.428 45.4902H88V42.9263H85.428V45.4902Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2839 45.4902H82.856V42.9263H80.2839V45.4902Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1399 45.4902H77.7119V42.9263H75.1399V45.4902Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9906 45.4902H72.5626V42.9263H69.9906V45.4902Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8466 45.4902H67.4186V42.9263H64.8466V45.4902Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7026 45.4902H62.2746V42.9263H59.7026V45.4902Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5585 45.4902H57.1305V42.9263H54.5585V45.4902Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4092 45.4902H51.9812V42.9263H49.4092V45.4902Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2651 45.4902H46.8372V42.9263H44.2651V45.4902Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.428 40.4155H88V37.8516H85.428V40.4155Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2839 40.4155H82.856V37.8516H80.2839V40.4155Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1399 40.4155H77.7119V37.8516H75.1399V40.4155Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9906 40.4155H72.5626V37.8516H69.9906V40.4155Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8466 40.4155H67.4186V37.8516H64.8466V40.4155Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7026 40.4155H62.2746V37.8516H59.7026V40.4155Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5585 40.4155H57.1305V37.8516H54.5585V40.4155Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4092 40.4155H51.9812V37.8516H49.4092V40.4155Z",
    fill: "#9AD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2651 40.4155H46.8372V37.8516H44.2651V40.4155Z",
    fill: "#9AD5EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_357_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 81,
    fill: "white",
    transform: "matrix(-1 0 0 -1 88 81)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame8);
export default __webpack_public_path__ + "static/media/frame-8.3c878a020e9d1f2801e40fec0dd9e899.svg";
export { ForwardRef as ReactComponent };